var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpgradePlanIcon = function SvgUpgradePlanIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#9AB86A",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3806_169646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4856 5.13965L6.15605 10.3351C5.98649 10.5386 5.90171 10.6403 5.90042 10.7263C5.89929 10.801 5.93258 10.872 5.99068 10.919C6.05751 10.973 6.18995 10.973 6.45481 10.973H9.99951L9.5134 14.8619L13.843 9.66639C14.0125 9.46291 14.0973 9.36118 14.0986 9.27526C14.0997 9.20056 14.0664 9.1295 14.0083 9.08255C13.9415 9.02854 13.8091 9.02854 13.5442 9.02854H9.99951L10.4856 5.13965Z",
    fill: "#9AB86A",
    stroke: "#9AB86A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3806_169646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6667,
    height: 11.6667,
    fill: "white",
    transform: "translate(4.16602 4.16699)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpgradePlanIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "upgrade-plan-icon.1c5929a8ce35a7fd38959ec207da1ae2.svg";